import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "right-arrow",
  "use": "right-arrow-usage",
  "viewBox": "0 0 140 90",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 140 90\" id=\"right-arrow\">\n  <path fill-rule=\"evenodd\" d=\"M103.384 17.116a1.25 1.25 0 0 0-1.768 1.768l22.866 22.866H12.5a1.25 1.25 0 0 0 0 2.5h111.982l-22.866 22.866a1.25 1.25 0 0 0 1.768 1.768l24.996-24.996a1.244 1.244 0 0 0 .366-.984 1.244 1.244 0 0 0-.362-.788l-25-25Z\" clip-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol